import './DeleteAccount.css';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import { navigationBarState } from '../../states/NavigationBar';
import { accessTokenState } from '../../states/Token';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import toast from 'react-hot-toast';
import AlertDialog, { AlertActionButton } from '../Common/Alert/Alert';

function DeleteAccount() {
    const navigate = useNavigate();
    const setNavigationBarState = useSetRecoilState(navigationBarState);
    const setAccessToken = useSetRecoilState(accessTokenState);

    const [confirmText, setConfirmText] = useState('');
    const [isDeleting, setIsDeleting] = useState(false);
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);

    const CONFIRM_KEYWORD = '탈퇴';

    useEffect(() => {
        window.scrollTo(0, 0);
        setNavigationBarState({
            title: '회원탈퇴',
            'left-item': { type: 'back' },
        });
    }, [setNavigationBarState]);

    const handleDeleteClick = () => {
        if (confirmText !== CONFIRM_KEYWORD) {
            toast.error(`'${CONFIRM_KEYWORD}'를 정확히 입력해주세요.`);
            return;
        }
        setShowConfirmDialog(true);
    };

    const handleDeleteAccount = async () => {
        setShowConfirmDialog(false);
        setIsDeleting(true);
        try {
            const response = await axios.delete('/users/me/');
            if (response.data.success) {
                toast.success('회원탈퇴가 완료되었습니다.');
                setAccessToken(null);
            } else {
                toast.error(response.data.message || '회원탈퇴에 실패했습니다.');
            }
        } catch (error) {
            toast.error(error.response?.data?.message || '회원탈퇴에 실패했습니다.');
        } finally {
            setIsDeleting(false);
        }
    };

    const isConfirmValid = confirmText === CONFIRM_KEYWORD;

    return (
        <div className="delete-account-page">
            <div className="delete-account-container">
                {/* Warning Box */}
                <div className="delete-account-warning-box">
                    <div className="delete-account-warning-title">
                        <ErrorOutlineIcon />
                        삭제되는 정보
                    </div>
                    <ul className="delete-account-warning-list">
                        <li className="delete-account-warning-item">모든 학습 기록</li>
                        <li className="delete-account-warning-item">모든 시험 응시 기록 및 성적</li>
                        <li className="delete-account-warning-item">계정 정보 (아이디, 이름, 연락처)</li>
                    </ul>
                </div>

                {/* Confirm Input */}
                <div className="delete-account-confirm">
                    <label className="delete-account-confirm-label">
                        확인을 위해 <strong>'{CONFIRM_KEYWORD}'</strong>를 입력해주세요
                    </label>
                    <input
                        type="text"
                        className={`delete-account-input ${isConfirmValid ? 'valid' : ''}`}
                        placeholder={CONFIRM_KEYWORD}
                        value={confirmText}
                        onChange={(e) => setConfirmText(e.target.value)}
                        autoComplete="off"
                    />
                </div>

                {/* Button */}
                <button
                    className="delete-account-btn danger"
                    onClick={handleDeleteClick}
                    disabled={!isConfirmValid || isDeleting}
                >
                    {isDeleting ? '처리중...' : '회원탈퇴'}
                </button>

                {/* Cancel Link */}
                <div className="delete-account-cancel-link">
                    <span onClick={() => navigate(-1)}>취소</span>
                </div>
            </div>

            {/* Confirm Dialog */}
            <AlertDialog
                open={showConfirmDialog}
                title="정말 탈퇴하시겠습니까?"
                description="탈퇴 후에는 복구가 불가능합니다."
                buttons={[
                    {
                        title: '취소',
                        action: () => setShowConfirmDialog(false)
                    },
                    {
                        title: '탈퇴',
                        type: AlertActionButton.KEYCOLOR,
                        action: handleDeleteAccount
                    }
                ]}
            />
        </div>
    );
}

export default DeleteAccount;
